import React, { ErrorInfo } from 'react';
import { ErrorPage } from 'shared-components';

interface Props {
  children?: React.ReactNode;
  resetKey?: string;
}
export class ErrorBoundary extends React.PureComponent<Props, { error?: Error; errorInfo?: ErrorInfo }> {
  constructor(props: Props) {
    super(props);
    this.state = { error: undefined, errorInfo: undefined };
  }

  componentDidUpdate(prevProps: Props): void {
    if (prevProps.resetKey !== this.props.resetKey && this.state.errorInfo) {
      this.setState({ error: undefined, errorInfo: undefined });
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    if (error !== this.state.error || errorInfo !== this.state.errorInfo) {
      this.setState({
        error,
        errorInfo,
      });
    }
  }

  render(): React.ReactNode {
    if (this.state.errorInfo) {
      return <ErrorPage errorCode="500" />;
    }
    return this.props.children;
  }
}
